import { makeStyles } from '@material-ui/core/styles';

const ITEM_HEIGHT = 38;
// https://mui.com/customization/palette/
export const useStyles = makeStyles((theme) => ({
  menuPaper: {
    maxHeight: ITEM_HEIGHT * 10,
    width: 300,
    backgroundColor: `${(theme as any).palette.background.dark1}`,
  },
  successColor: {
    color: `${(theme as any).palette.success.light}`,
    '&.Mui-checked': {
      color: `${(theme as any).palette.success.light}`,
    },
  },
  errorColor: {
    color: `${(theme as any).palette.error.light}`,
    '&.Mui-checked': {
      color: `${(theme as any).palette.error.light}`,
    },
  },
  defaultColor: {
    color: `${(theme as any).palette.text.notes}`,
    '&.Mui-checked': {
      color: `${(theme as any).palette.text.notes}`,
    },
  },
  badge: {
    backgroundColor: `${(theme as any).palette.success.light}`,
    color: `${(theme as any).palette.background.paper}`,
    height: '15px',
    width: '15px',
    minWidth: '15px',
  },
  noBadge: {
    backgroundColor: `${(theme as any).palette.background.paper}`,
    color: `${(theme as any).palette.background.paper}`,
  },
  badgePosition: {
    // transform: 'scale(1) translate(-85%, 90%)',
    transform: 'scale(1) translate(-0%, 0%)',
  },
  otherMenuHospice: {
    maxHeight: ITEM_HEIGHT * 15,
    width: 250,
    backgroundColor: `${(theme as any).palette.background.dark1}`,
  },
  medsMenu: {
    maxHeight: ITEM_HEIGHT * 15,
    width: 300,
    backgroundColor: `${(theme as any).palette.background.dark1}`,
  },
  introMenu: {
    maxHeight: ITEM_HEIGHT * 15,
    width: 220,
    backgroundColor: `${(theme as any).palette.background.dark1}`,
  },
  defaultMenu: {
    maxHeight: ITEM_HEIGHT * 15,
    width: 250,
    backgroundColor: `${(theme as any).palette.background.dark1}`,
  },
  textField: {
    width: '90px',
  },
  label: {
    fontSize: '0.85rem',
  },
  inputField: {
    fontSize: '1rem',
    paddingBottom: '35px',
    borderRadius: '0px',
    width: '100%',
  },
  orderNoteField: {
    borderRadius: '0px',
    fontSize: '1rem',
    padding: '6px',
    width: '100%',
  },
  inputFieldBorder: {
    border: `1px solid ${(theme as any).palette.primary.main}`,
    borderTop: '0px',
    width: '100%',
  },
  widthGeneralOrder: {
    width: '40%',
  },
  generalOrderInput: {
    fontSize: '1rem',
    padding: '6px',
  },
  generalOrderRoot: {
    border: `1px solid ${(theme as any).palette.primary.main}`,
    borderRadius: '0px',
  },
  loadButton: {
    height: '25px',
    width: '100%',
  },
  loadAllButton: {
    height: '25px',
    width: '100%',
    backgroundColor: `${(theme as any).palette.success.main}`,
  },
  inputFieldHeight: () => {
    const { getFullSizeHeight } = (theme as any).props.dashboard;
    const maxHeight = getFullSizeHeight(window.innerHeight);
    return {
      maxHeight: maxHeight * 0.6,
      'overflow-y': 'scroll !important',
    };
  },
}));
